import { createApp } from 'vue/dist/vue.esm-bundler';
import Events from './Events.vue';


const mountEl = document.querySelector('[data-app-events-list]');

if ( mountEl )
{
    createApp(Events, { 
        ...mountEl.dataset 
    }).mount(mountEl);
}